import { useContext } from 'react';

import TownAssetsContext from './TownAssetsContext';

const useTownAssets = () => {
  const context = useContext(TownAssetsContext);
  if (context === null) {
    throw new Error('useTownAssets must be used within a TownAssetsProvider');
  }
  return context;
};

export default useTownAssets;
